const testimonials = [
  {
    name: 'Marcus Johnson',
    role: 'Operations Manager · CoolAir HVAC',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20operations%20manager%20portrait%20headshot%20clean%20white%20background%20confident%20smile%20business%20casual%20attire&width=80&height=80&seq=t001&orientation=squarish',
    text: "finfins completely transformed how we dispatch. We've cut response time by half and our customers keep commenting on how smooth and eco-friendly everything feels.",
    rating: 5,
  },
  {
    name: 'Sarah Mitchell',
    role: 'Owner · Mitchell Green Cleaning Co.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20business%20owner%20portrait%20headshot%20clean%20white%20background%20warm%20smile%20business%20attire%20natural%20lighting&width=80&height=80&seq=t002&orientation=squarish',
    text: 'The scheduling AI is insane. It knows which cleaner to send before I even think about it. My team is finally happy and customers stopped calling to check status.',
    rating: 5,
  },
  {
    name: 'David Chen',
    role: 'Director of Service · EcoSpark Solutions',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20director%20portrait%20headshot%20clean%20background%20professional%20attire%20confident%20expression%20corporate%20photo&width=80&height=80&seq=t003&orientation=squarish',
    text: "We manage 40+ cleaners across 3 cities. finfins' analytics help me spot problems before they become expensive. ROI was clear within 2 weeks.",
    rating: 5,
  },
];

export default function TestimonialsSection() {
  return (
    <section className="px-5 py-10 bg-white">
      <div className="text-center mb-7">
        <span className="inline-block bg-green-50 text-green-600 text-[10px] font-bold tracking-widest uppercase px-3 py-1 rounded-full border border-green-100 mb-3">
          Testimonials
        </span>
        <h2 className="text-gray-800 font-bold text-2xl leading-tight">
          Loved by Green Service<br />Professionals
        </h2>
      </div>

      <div className="space-y-4">
        {testimonials.map((t) => (
          <div key={t.name} className="bg-[#f8f9fa] rounded-xl border border-gray-100 p-4">
            <div className="flex items-center gap-1 mb-3">
              {Array.from({ length: t.rating }).map((_, i) => (
                <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
              ))}
            </div>
            <p className="text-gray-600 text-xs leading-relaxed mb-4 italic">
              &ldquo;{t.text}&rdquo;
            </p>
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0 border border-gray-200">
                <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
              </div>
              <div>
                <div className="text-gray-800 font-semibold text-xs">{t.name}</div>
                <div className="text-gray-400 text-[10px]">{t.role}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
